import { render, staticRenderFns } from "./allTrajectory.vue?vue&type=template&id=6c1bfd2c&scoped=true&"
import script from "./allTrajectory.vue?vue&type=script&lang=js&"
export * from "./allTrajectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bfd2c",
  null
  
)

export default component.exports